export enum EventEmitterEvent {
  Navigate = 'navigate',
}
